import moment from 'moment-timezone'
import { OpportunityResponseWithRecurrenceInfo, OpportunityStatus } from 'Event/interfaces/interfaceCreateEditEvent'
import { Organization } from 'organization/types'

export const getEventPublishDisplayStatus = (
  event: OpportunityResponseWithRecurrenceInfo,
  org: Pick<Organization, 'timeZone' | 'limitFutureEventVisibility'> & {
    futureEventVisibilityDays?: number | null
  },
): string => {
  if (event.status === OpportunityStatus.Draft) {
    return event.status
  }

  const timeZone = org.timeZone || moment.tz.guess()

  if (event.forceVisibleAt && moment(event.forceVisibleAt).tz(timeZone).isAfter(moment())) {
    const publishMoment = moment(event.forceVisibleAt).tz(timeZone)
    return `Hidden until ${publishMoment.format('MMMM D, YYYY [at] h:mm A')} ${publishMoment.format('z')}`
  }

  if (org.limitFutureEventVisibility) {
    const isAfterVisibilityHorizon = moment(event.startsAt)
      .tz(timeZone)
      .startOf('day')
      .subtract(org.futureEventVisibilityDays ?? 0, 'days')
      .isAfter(moment())

    if (isAfterVisibilityHorizon) {
      return 'Hidden'
    }
  }

  return 'Published'
}

export const getLegacyEventOverviewStatus = (
  event: OpportunityResponseWithRecurrenceInfo,
  org: Pick<Organization, 'timeZone' | 'limitFutureEventVisibility'> & {
    futureEventVisibilityDays?: number | null
  },
): string => {
  if (event.status === OpportunityStatus.Draft) {
    return event.status
  }

  const timeZone = org.timeZone || moment.tz.guess()

  if (event.forceVisibleAt) {
    const isBeforePublishDate = moment(event.forceVisibleAt).tz(timeZone).isAfter(moment())
    return isBeforePublishDate ? 'Hidden' : event.status
  }

  if (org.limitFutureEventVisibility) {
    const isAfterVisibilityHorizon = moment(event.startsAt)
      .tz(timeZone)
      .startOf('day')
      .subtract(org.futureEventVisibilityDays ?? 0, 'days')
      .isAfter(moment())

    if (isAfterVisibilityHorizon) {
      return 'Hidden'
    }
  }

  return event.status
}
